/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const resourceKindEnum = {
  person: 'person',
  organisation: 'organisation',
  role: 'role',
  equipment: 'equipment',
  material: 'material',
} as const;

export type ResourceKindEnumSchemaKey = (typeof resourceKindEnum)[keyof typeof resourceKindEnum];

export type ResourceKindSchema = ResourceKindEnumSchemaKey;
